import { setAuthKey } from "@/services/api/BASE_URL";

export default {
  namespaced: true,
  state: {
    isLogin: localStorage.getItem("authToken") ? true : false,
    user: (() => {
      try {
        const userProfile = localStorage.getItem("userProfile");
        return userProfile ? JSON.parse(userProfile) : null;
      } catch (error) {
        console.error("Failed to parse userProfile from localStorage:", error);
        return null;
      }
    })(),
    authToken: localStorage.getItem("authToken") || null,
  },
  mutations: {
    userLogin(state, { userObj, token }) {
      state.user = userObj;
      state.authToken = token;
      state.isLogin = true;
    },
    userLogout(state) {
      state.user = null;
      state.isLogin = false;
      state.authToken = false;
      localStorage.clear();
      setAuthKey("");
    },
    userUpdate(state, payload) {
      Object.keys(payload).forEach((key) => {
        if (key in state.user && payload[key] != null) {
          state.user[key] = payload[key];
        }
      });
      localStorage.setItem('userProfile', JSON.stringify(state.user))
    },
  },
  actions: {},
  getters: {
    isLogin: (state) => state.isLogin,
    userRole: (state) => state.user?.role,
    userId: (state) => state.user?.id,
  },
};
